import { render, staticRenderFns } from "./PledgePage.vue?vue&type=template&id=ea818824&"
import script from "./PledgePage.vue?vue&type=script&lang=js&"
export * from "./PledgePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports